var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00023 21C9.00023 20.4477 9.44794 20 10.0002 20H14.0002C14.5525 20 15.0002 20.4477 15.0002 21C15.0002 21.5523 14.5525 22 14.0002 22H10.0002C9.44794 22 9.00023 21.5523 9.00023 21Z",
    fill: "#462AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05048 3.05025C8.36323 1.7375 10.1437 1 12.0002 1C13.8567 1 15.6372 1.7375 16.95 3.05025C18.2627 4.36301 19.0002 6.14349 19.0002 8C19.0002 10.9127 19.7322 12.8439 20.4996 14.0771L20.5115 14.0962C20.8688 14.6704 21.1512 15.1243 21.3416 15.4547C21.4371 15.6202 21.524 15.7797 21.5884 15.9215C21.6205 15.9922 21.6564 16.079 21.6845 16.1733C21.7078 16.2515 21.7522 16.4187 21.7356 16.6223C21.7244 16.7591 21.6965 16.9928 21.5623 17.2343C21.4282 17.4758 21.2445 17.623 21.1342 17.7047C20.8839 17.8904 20.5965 17.9329 20.5006 17.947L20.4961 17.9477C20.3487 17.9695 20.1815 17.9804 20.0127 17.9869C19.6774 18 19.2133 18 18.6361 18H5.36437C4.78715 18 4.32301 18 3.98775 17.9869C3.819 17.9804 3.65172 17.9695 3.50431 17.9477L3.49988 17.947C3.40396 17.9329 3.11653 17.8904 2.86623 17.7047C2.75599 17.623 2.57227 17.4758 2.43811 17.2343C2.30396 16.9928 2.27607 16.7591 2.26488 16.6223C2.24823 16.4187 2.29263 16.2515 2.31594 16.1733C2.34403 16.079 2.37997 15.9922 2.4121 15.9215C2.47646 15.7797 2.5634 15.6202 2.65882 15.4547C2.84925 15.1243 3.13172 14.6703 3.48905 14.0961L3.50084 14.0771C4.26822 12.8439 5.00023 10.9127 5.00023 8C5.00023 6.14348 5.73772 4.36301 7.05048 3.05025Z",
    fill: "#462AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBlueIcon);
export default __webpack_public_path__ + "static/media/notification-blue-icon.191d2d813951ed9bf57040fdc2204627.svg";
export { ForwardRef as ReactComponent };